/* @flow */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '@uniiverse/library/components/button';
import MarkerIcon from '@uniiverse/library/assets/icons/marker.svg';
import WebsiteIcon from '@uniiverse/library/assets/icons/website.svg';
import FacebookIcon from '@uniiverse/library/assets/icons/facebook.svg';
import TwitterIcon from '@uniiverse/library/assets/icons/twitter.svg';
import InstagramIcon from '@uniiverse/library/assets/icons/instagram.svg';
import Card from '../../card/index';
import Avatar from '../avatar/index';

import { isPrivate } from '../../../modules/profile/getters';

import style from './index-module.css';

type Props = {
  data: ProfileQuery,
  currentUser: Object,
};

const MessageButton: Function = (props: Props): ?React$Element<*> => {
  const { data: { profile }, currentUser } = props;
  if (currentUser && currentUser.id === profile.id) return null;

  if (!profile.messageable) return null;

  const redirectToMessage: Function = () => {
    window.location.href = `/dashboard/conversations/withUser/${profile.id || ''}`;
    return false;
  };
  return (
    <div className={style.message}>
      <Button onClick={redirectToMessage} size="default" type="primary">
        <FormattedMessage id="profile.message-user" defaultMessage="Message" />
      </Button>
    </div>
  );
};

const Description: Function = (props: Props): ?React$Element<*> => {
  const { data: { profile }} = props;

  if (!profile.description) {
    return null;
  }

  const description = new DOMParser().parseFromString(profile.description || '', 'text/html');
  let parsedstr;
  if (description.documentElement){
    parsedstr = description.documentElement.textContent;
  }
  return <div className={style.description}>{parsedstr}</div>;
};

const Location: Function = (props: Props): ?React$Element<*> => {
  const { data: { profile }} = props;

  if (!profile.location) return null;

  // hide the host city for Encore Live (garth brooks) events
  if (/Encore Live/ig.test(profile.description || '')) return null;

  return (
    <div className={style.location}>
      <MarkerIcon className="Icon" />
      {profile.location}
    </div>
  );
};

const normalizedUrl: Function = (url: ?string): ?string => {
  if (!url || url.trim() === '') {
    return null;
  }

  if (url.indexOf('://') === -1) {
    return `http://${url}`;
  }

  return url;
};

const Links: Function = (props: Props): ?React$Element<*> => {
  const { data: { profile }} = props;

  const websiteUrl = normalizedUrl(profile.website);
  const facebookUrl = normalizedUrl(profile.facebook);
  const twitterUrl = normalizedUrl(profile.twitter);
  const instagramUrl = normalizedUrl(profile.instagram);

  if (!websiteUrl && !facebookUrl && !twitterUrl && !instagramUrl) {
    return null;
  }

  return (
    <div className={style.links}>
      {websiteUrl && <div><a href={websiteUrl}><WebsiteIcon /></a></div>}
      {facebookUrl && <div><a href={facebookUrl}><FacebookIcon /></a></div>}
      {twitterUrl && <div><a href={twitterUrl}><TwitterIcon /></a></div>}
      {instagramUrl && <div><a href={instagramUrl}><InstagramIcon /></a></div>}
    </div>
  );
};

const ProfileInfo: Function = (props: Props): React$Element<*> => {
  const { data: { profile }} = props;

  if (isPrivate(profile)) {
    return (
      <Card className={style.container}>
        <Avatar {...props} />
        <div className={style.name} data-cs-mask={true}>{profile.name}</div>
      </Card>
    );
  }

  return (
    <Card className={style.container}>
      <Avatar {...props} />
      <div className={style.name} data-cs-mask={true}>{profile.name}</div>
      <Location {...props} />
      <MessageButton {...props} />
      <Description {...props} />
      <Links {...props} />
    </Card>
  );
};

export default ProfileInfo;



// WEBPACK FOOTER //
// ./src/components/profile/profile-info/index.js